import React, { useState } from 'react';

function PreChatForm({ onStartChat }) {
  const [contact, setContact] = useState('');
  const [subject, setSubject] = useState('');
  const [name, setName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!contact || !subject || !name) return;
    onStartChat({ contact, subject, name });
  };

  return (
    <div className="prechat-wrapper">
      <form onSubmit={handleSubmit} className="prechat-form">
        <h2 className="prechat-title">Start Your Message</h2>

        <div className="form-group">
          <label htmlFor="contact">Who do you want to talk to?</label>
          <input
            id="contact"
            type="text"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            placeholder="e.g. Mom, Dad, My Boss"
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">What is the subject?</label>
          <input
            id="subject"
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            placeholder="e.g. What happened"
          />
        </div>

        <div className="form-group">
          <label htmlFor="name">Your name (or leave anonymous)</label>
          <input
            id="name"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. David"
          />
        </div>

        <button type="submit" className="start-chat-button">
          Start Conversation
        </button>
      </form>
    </div>
  );
}

export default PreChatForm;
